import { render, staticRenderFns } from "./Noleggio.vue?vue&type=template&id=4a28deb4"
import script from "./Noleggio.vue?vue&type=script&lang=js"
export * from "./Noleggio.vue?vue&type=script&lang=js"
import style0 from "./Noleggio.vue?vue&type=style&index=0&id=4a28deb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports